export default __webpack_public_path__ + "static/media/laboratories_light.1cc33bb2.svg";